export const filterTypeLabels = {
  ALL: "All matches",
  PEOPLE: "People",
  POSITIONS: "Positions",
  TEAM: "Teams",
  TAGS: "Tags",
};

export const filterTypes = {
  ALL: "all",
  PEOPLE: "people",
  POSITIONS: "positions",
  TEAMS: "teams",
  TAGS: "tags",
};

/**
 * Position occupancy filter for global search (maps to PositionOccupancyStatus).
 * ALL = omit filter (every status). Other values are API enum values.
 */
export const positionOccupancyStatus = {
  ALL: "all",
  VACANT: "VACANT",
  PARTIALLY_FILLED: "PARTIALLY_FILLED",
  FILLED: "FILLED",
  OVER_FILLED: "OVER_FILLED",
};

/** Radio options for the Positions status filter (All + each API status). */
export const positionOccupancyStatusFilterOptions = [
  { value: positionOccupancyStatus.ALL, label: "All" },
  { value: positionOccupancyStatus.VACANT, label: "Open" },
  {
    value: positionOccupancyStatus.PARTIALLY_FILLED,
    label: "Partially filled",
  },
  { value: positionOccupancyStatus.FILLED, label: "Filled" },
  { value: positionOccupancyStatus.OVER_FILLED, label: "Over-filled" },
];

/** API enum values only (URL / query param validation). */
export const positionOccupancyStatusApiValues = [
  positionOccupancyStatus.VACANT,
  positionOccupancyStatus.PARTIALLY_FILLED,
  positionOccupancyStatus.FILLED,
  positionOccupancyStatus.OVER_FILLED,
];

/** Field filters for Positions (PersonFieldsToSearch values; labels are UI-facing). */
export const positionFieldFilterItems = [
  { label: "Position name", name: "preferredName" },
  { label: "Position ID", name: "id" },
];
